import { render, staticRenderFns } from "./JdeAccountSetup.vue?vue&type=template&id=af2e3684&scoped=true"
import script from "./JdeAccountSetup.vue?vue&type=script&lang=ts"
export * from "./JdeAccountSetup.vue?vue&type=script&lang=ts"
import style0 from "./JdeAccountSetup.vue?vue&type=style&index=0&id=af2e3684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2e3684",
  null
  
)

export default component.exports